export function numeroALetras(xnum) {
    let num = parseFloat(xnum);
    console.log("num=",num,"xnum=",xnum)
    const unidades = ['CERO', 'UNO', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
    const decenas = ['DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISÉIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE'];
    const decenasDiez = ['', '', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
    const centenas = ['', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'];
  
    if (num === 0) return 'CERO';
  
    const getUnidades = (n) => unidades[n];
    const getDecenas = (n) => (n < 10 ? getUnidades(n) : (n < 20 ? decenas[n - 10] : decenasDiez[Math.floor(n / 10)] + (n % 10 !== 0 ? ' Y ' + getUnidades(n % 10) : '')));
    const getCentenas = (n) => (n === 100 ? 'CIEN' : centenas[Math.floor(n / 100)] + (n % 100 !== 0 ? ' ' + getDecenas(n % 100) : ''));
    
    const getMiles = (n) => {
        if (n < 1000) return getCentenas(n);
        return (n < 2000 ? 'MIL ' : getCentenas(Math.floor(n / 1000)) + ' MIL ') + (n % 1000 !== 0 ? getCentenas(n % 1000) : '');
    };
  
    const getMillones = (n) => {
        if (n < 1000000) return getMiles(n);
        return (n < 2000000 ? 'UN MILLÓN ' : getMiles(Math.floor(n / 1000000)) + ' MILLONES ') + (n % 1000000 !== 0 ? getMiles(n % 1000000) : '');
    };
  
    // Obtener parte entera y parte decimal
    const [entero, decimal] = num.toFixed(2).split('.');
    console.log("Entero=",entero, "decimal=",decimal)
  
    const literal = getMillones(parseInt(entero, 10)).trim();
    const decimalLiteral = `${decimal}/100`;
  
    console.log("literal=",literal)
  
    return `${literal} ${decimalLiteral}`.toUpperCase();
  }
  